export default "__VITE_ASSET__2e0a588a__"